import styled, { css } from 'styled-components';
import { RowProps, ColProps } from './layout.d';


export const Row = styled.div<RowProps>`

    width: ${({ width }) => width ?? "100%"};

    margin: ${({ margin }) => margin ?? "0"};
    padding: ${({ padding }) => padding ?? "0"};

    display: flex;
    align-items: ${({ crossAxis }) => crossAxis ?? "center"};
    justify-content: ${({ mainAxis }) => mainAxis ?? "flex-start"};

    gap: ${({ gap }) => gap ?? "normal"};
    ${({ rowGap }) => rowGap ?? css`row-gap:${rowGap};`}
    ${({ columnGap }) => columnGap ?? css`column-gap:${columnGap};`}
    ${({ flexWrap }) => flexWrap && css`flex-wrap: ${flexWrap};`}
    flex-direction: row;
    ${({ height }) => height && css`height: ${height};`}
`;

export const Col = styled.div<ColProps>`

    width: ${({ width }) => width ?? "auto"};

    margin: ${({ margin }) => margin ?? "0"};
    padding: ${({ padding }) => padding ?? "0"};

    display: flex;
    align-items: ${({ crossAxis }) => crossAxis ?? "center"};
    justify-content: ${({ mainAxis }) => mainAxis ?? "flex-start"};

    gap: ${({ gap }) => gap ?? "normal"};
    ${({ rowGap }) => rowGap ?? css`row-gap:${rowGap};`}
    ${({ columnGap }) => columnGap ?? css`column-gap:${columnGap};`}
    ${({ flexWrap }) => flexWrap && css`flex-wrap: ${flexWrap};`}
    flex-direction: column;
`;
